import {
  STATUSES_COUNTS_BY_ESTIMATOR_REQUEST,
  STATUSES_COUNTS_BY_ESTIMATOR_REQUEST_SUCCESS,
  STATUSES_COUNTS_BY_ESTIMATOR_REQUEST_FAILURE
} from "actions/statistics/statuses-counts-by-estimator-actions";
import { RESET_DATA } from "actions/jobs-tabs-actions";

const INITIAL_STATE = { data: [], error: null, loading: false };

const StatusesCountsByEstimatorReducer = (state = INITIAL_STATE, action) => {
  let error;
  switch(action.type) {
    case STATUSES_COUNTS_BY_ESTIMATOR_REQUEST:
      return {...state, error: null, loading: true};
    case STATUSES_COUNTS_BY_ESTIMATOR_REQUEST_SUCCESS:
      return {...state, data: action.payload, loading: false};
    case STATUSES_COUNTS_BY_ESTIMATOR_REQUEST_FAILURE:
      error = action.payload || {message: action.payload.message};
      return {...state, error: error, loading: false};
    case RESET_DATA:
      return {...state, data: []};

    default:
      return state;
  }
};

export default StatusesCountsByEstimatorReducer
